import Vue from 'vue';
import { memberChangeBindingSa } from '../../../services/personnelService/bindSaService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  changeSaInfo: null
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async memberChangeBindingSaHandler({}, bindingInfo) {
    const data = await memberChangeBindingSa(bindingInfo);
    return data;
  }
};

// mutations
const mutations = {
  saveChangeSaInfo(state, data) {
    Vue.set(state, 'changeSaInfo', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
